import React, { Component } from "react";
import firebase from "../firebase";
import Sidebar from "../includes/Sidebar";

export default class Page extends Component {
  state = {
    pageId: "",
    pageName: "",
    title: "",
    content: "",
    bannerUrl: localStorage.bannerUrl ? localStorage.bannerUrl : ""
  };

  componentDidMount() {
    let page = window.location.href.split("/")[3];
    firebase
      .database()
      .ref("/pages")
      .on("value", snap => {
        let val = snap.val();
        val.map((el, idx) => {
          if (el.title.toLowerCase() === page) {
            return this.setState({ pageId: idx, pageName: page }, () =>
              this.fetchPageContent()
            );
          }
          return null;
        });
      });

    let banner = firebase.database().ref("banner");
    banner.on("value", snap => {
      this.setState({ bannerUrl: snap.val() }, () => {
        localStorage.bannerUrl = snap.val();
      });
    });
  }

  fetchPageContent = () => {
    let page = firebase.database().ref(`/pages/${this.state.pageId}`);
    page.on("value", snap => {
      let val = snap.val();
      this.setState({ title: val.title, content: val.content });
    });
  };

  componentWillUnmount() {
    firebase
      .database()
      .ref()
      .off();
  }

  toHtml = html => {
    return { __html: html };
  };

  render() {
    let banner = (
      <div
        className="banner-container"
        style={{ backgroundImage: `url(${this.state.bannerUrl})` }}
      />
    );

    let title = <h1 className="page-title">{this.state.title}</h1>;

    let content = (
      <article className="page-content col-xs-12 col-sm-6 col-lg-8">
        <div dangerouslySetInnerHTML={this.toHtml(this.state.content)} />
      </article>
    );

    return (
      <section className={`${this.state.pageName}-content-container`}>
        {banner}
        <section className="content-inner wrap clearfix">
          {title}
          {content}
          <Sidebar />
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Page.js